import { MdFamilyRestroom, MdWork, MdSearch, MdAccessTime, MdPayment, MdPerson } from 'react-icons/md';
import { t } from '../../utils/i18n';

const PARENT_ITEMS = [
  { key: 'item1', icon: MdSearch },
  { key: 'item2', icon: MdAccessTime },
  { key: 'item3', icon: MdPayment },
];

const SITTER_ITEMS = [
  { key: 'item1', icon: MdWork },
  { key: 'item2', icon: MdAccessTime },
  { key: 'item3', icon: MdPerson },
];

export default function BenefitsSection() {
  return (
    <section className="relative z-20 py-12 sm:py-14 lg:py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-10">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-[var(--color-text)] mb-2 tracking-tight">
            {t('landing.benefits.title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-6">
          <BenefitCard
            title={t('landing.benefits.parents.title')}
            icon={MdFamilyRestroom}
            items={PARENT_ITEMS}
            prefix="landing.benefits.parents"
            variant="parents"
          />
          <BenefitCard
            title={t('landing.benefits.sitters.title')}
            icon={MdWork}
            items={SITTER_ITEMS}
            prefix="landing.benefits.sitters"
            variant="sitters"
          />
        </div>
      </div>
    </section>
  );
}

function BenefitCard({ title, icon: HeaderIcon, items, prefix, variant }) {
  return (
    <div
      className={`landing-benefit-card rounded-2xl p-5 sm:p-6 transition-all duration-300 ${
        variant === 'parents' ? 'landing-benefit-card--parents' : 'landing-benefit-card--sitters'
      }`}
    >
      <div className="flex items-center gap-3 mb-5">
        <div className="w-11 h-11 rounded-xl flex items-center justify-center landing-benefit-icon">
          <HeaderIcon className="text-xl text-primary-600 dark:text-primary-400" aria-hidden="true" />
        </div>
        <h3 className="text-lg sm:text-xl font-semibold text-[var(--color-text)]">{title}</h3>
      </div>
      <ul className="space-y-3.5">
        {items.map(({ key, icon: Icon }) => (
          <li key={key} className="flex items-start gap-3">
            <span className="mt-0.5 w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 landing-benefit-item-icon">
              <Icon className="text-base text-[var(--color-text-muted)]" aria-hidden="true" />
            </span>
            <span className="text-sm sm:text-base text-[var(--color-text-muted)] leading-relaxed pt-1">
              {t(`${prefix}.${key}`)}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
